import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Tier 1 locale imports (lazy-loaded per namespace in production)
import enCommon from '../locales/en/common.json';
import deCommon from '../locales/de/common.json';
import frCommon from '../locales/fr/common.json';
import esCommon from '../locales/es/common.json';
import nlCommon from '../locales/nl/common.json';
import ptCommon from '../locales/pt/common.json';
import faCommon from '../locales/fa/common.json';
import arCommon from '../locales/ar/common.json';

export const SUPPORTED_LOCALES = [
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'de', name: 'Deutsch', dir: 'ltr' },
  { code: 'fr', name: 'Français', dir: 'ltr' },
  { code: 'es', name: 'Español', dir: 'ltr' },
  { code: 'nl', name: 'Nederlands', dir: 'ltr' },
  { code: 'pt', name: 'Português', dir: 'ltr' },
  { code: 'fa', name: 'فارسی', dir: 'rtl' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
] as const;

export const RTL_LOCALES = ['fa', 'ar', 'he'];

export function isRtl(locale: string): boolean {
  return RTL_LOCALES.includes(locale);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      de: { common: deCommon },
      fr: { common: frCommon },
      es: { common: esCommon },
      nl: { common: nlCommon },
      pt: { common: ptCommon },
      fa: { common: faCommon },
      ar: { common: arCommon },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Update document direction when language changes
i18n.on('languageChanged', (lng) => {
  const dir = isRtl(lng) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
